export enum SelectionType {
  all = 'all',
  selected = 'selected',
  unselected = 'unselected',
}
